import { useEffect } from "react";
import { LAST_FEEDBACK_DATE_STORAGE_KEY, FEEDBACK_DISABLE_PERIOD } from "../constants/feedbackForm";
import { useSelector } from "react-redux";
import { feedbackAvailableSelector } from "../store/feedback/selectors";
import { useActions } from "./useActions";

export const getIsFeedbackAvailableFromStorage: () => boolean = () => {
  const lastFeedbackDate: number = +(localStorage.getItem(LAST_FEEDBACK_DATE_STORAGE_KEY) || "");
  const dateNow = +new Date();
  if (lastFeedbackDate) {
    if (dateNow - lastFeedbackDate >= FEEDBACK_DISABLE_PERIOD) {
      localStorage.removeItem(LAST_FEEDBACK_DATE_STORAGE_KEY);
      return true;
    }
    return false;
  }
  return true;
};

const useFeedback: () => { isFeedbackAvailable: boolean } = () => {
  const isFeedbackAvailable = useSelector(feedbackAvailableSelector);
  const { setFeedbackAvailableAction } = useActions();

  useEffect(() => {
    const lastFeedbackDate: number = +(localStorage.getItem(LAST_FEEDBACK_DATE_STORAGE_KEY) || "");
    if (lastFeedbackDate) {
      const dateNow = +new Date();
      const remainingTime = FEEDBACK_DISABLE_PERIOD - (lastFeedbackDate - dateNow);
      const id = setInterval(() => {
        localStorage.removeItem(LAST_FEEDBACK_DATE_STORAGE_KEY);
        setFeedbackAvailableAction(true);
        clearInterval(id);
      }, remainingTime);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isFeedbackAvailable && getIsFeedbackAvailableFromStorage()) {
      const dateNow = +new Date();
      localStorage.setItem(LAST_FEEDBACK_DATE_STORAGE_KEY, dateNow.toString());
    }
    // eslint-disable-next-line
  }, [isFeedbackAvailable]);
  return { isFeedbackAvailable };
};

export default useFeedback;
